<div *ngIf="eventsManager.showLoading" class="cssload-container">
  <div class="cssload-speeding-wheel"></div>
</div>
